export default __webpack_public_path__ + "static/media/thankyou.941b298f.png";